import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=f2ab19ea&scoped=true&"
import script from "./Challenge.vue?vue&type=script&lang=js&"
export * from "./Challenge.vue?vue&type=script&lang=js&"
import style0 from "./Challenge.vue?vue&type=style&index=0&id=f2ab19ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ab19ea",
  null
  
)

export default component.exports